import { SupportedLanguage } from '@/constants/language';
import { generateHomeUrl, generateSupportUrl } from '@/constants';
import { getSupportedLanguage } from '@/utils/language';
import { Service, WebSite, WithContext } from 'schema-dts';

// 사이트 레벨 정체성 노드의 canonical @id (locale 무관). 페이지 그래프는 이 @id 로 참조하고,
// 각 빌더(Organization·WebSite)도 이 상수로 자기 @id 를 정의한다 — 접미사 중복 하드코딩 방지.
const SITE_JSONLD_URL = generateHomeUrl({ isProduction: true });
export const ORGANIZATION_JSONLD_ID = `${SITE_JSONLD_URL}#organization`;
export const WEBSITE_JSONLD_ID = `${SITE_JSONLD_URL}#website`;

/**
 * 사이트 레벨 WebSite 노드. `@id` 로 페이지 그래프에서 `isPartOf` 참조 대상이 되고,
 * publisher 는 canonical Organization(`ORGANIZATION_JSONLD_ID`)을 @id 로 가리킨다.
 */
export const generateWebSiteJsonLd = (
  locale: string,
): WithContext<WebSite> => ({
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  '@id': WEBSITE_JSONLD_ID,
  url: SITE_JSONLD_URL,
  name: '3Billion',
  inLanguage: getSupportedLanguage(locale),
  publisher: { '@id': ORGANIZATION_JSONLD_ID },
});

export const generateServiceBaseJsonLd = (
  language: SupportedLanguage,
): WithContext<Service> => {
  return {
    '@context': 'https://schema.org',
    '@type': 'Service',
    brand: {
      '@type': 'Organization',
      name: '3Billion Inc.',
      url: generateHomeUrl({ language, isProduction: true }),
    },
    provider: {
      '@type': 'Organization',
      name: '3Billion Inc.',
      url: generateHomeUrl({ language, isProduction: true }),
    },
    availableChannel: {
      '@type': 'ServiceChannel',
      serviceUrl: generateSupportUrl({ language, isProduction: true }),
      availableLanguage: ['ko', 'en'],
    },
  };
};
